export function concatMatrices<T>([arr, ...restArrs]: T[][][]) {
  return arr.map((row, rowIndex) => {
    const restRows = restArrs.flatMap(restArr => restArr[rowIndex]);
    return [...row, ...restRows];
  });
}
